/*
  (c) GRIND LIFESTYLE - ALL RIGHTS RESERVED.
  All code on this website is owned by Chauncey Kochel. Copying, reproducing,
  or reusing any code from this website is strictly forbidden and may result
  in legal action.
*/
(function () {
  'use strict';

  /* v1.39.1: version echo — open the console on any device to confirm the running version */
  try { console.log('%cGRIND THEME v1.49.7', 'color:#a4f34a;font-weight:bold'); } catch (e) {}

  /* ---------- Menu drawer (headstock peek slides out) ---------- */
  var drawer = document.getElementById('GrindDrawer');
  var panel = document.getElementById('GrindDrawerPanel');
  var closeBtn = document.getElementById('GrindMenuClose');
  var scrim = document.getElementById('GrindDrawerScrim');

  function drawerIsOpen() {
    return drawer && drawer.classList.contains('is-open');
  }
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (panel) {
    panel.addEventListener('click', function (e) {
      if (!drawerIsOpen()) {
        e.preventDefault();
        openDrawer();
      }
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      if (drawerIsOpen()) {
        e.stopPropagation();
        closeDrawer();
      }
    });
  }
  if (scrim) scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    var badge = document.getElementById('GrindCartCount');
    if (!badge) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      })
      .catch(function () { /* leave as rendered */ });
  }
  refreshCartCount();

  /* ---------- Product page: variant resolution ---------- */
  var productForm = document.getElementById('GrindProductForm');
  if (productForm) {
    var dataEl = document.getElementById('GrindProductJSON');
    var product = null;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { product = null; }

    var idInput = productForm.querySelector('input[name="id"]');
    var selects = productForm.querySelectorAll('select[data-option-index]');
    var addBtn = document.getElementById('GrindAddToCart');
    var priceEl = document.getElementById('GrindProductPrice');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function resolveVariant() {
      if (!product) return;
      var chosen = [];
      selects.forEach(function (s) { chosen[parseInt(s.dataset.optionIndex, 10)] = s.value; });
      var match = product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (match) {
        idInput.value = match.id;
        if (priceEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            priceEl.innerHTML = '<s>' + formatMoney(match.compare_at_price) + '</s>' + formatMoney(match.price);
          } else {
            priceEl.textContent = formatMoney(match.price);
          }
        }
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
        }
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.labelUnavailable;
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', resolveVariant); });
    resolveVariant();
  }

  /* ---------- Polaroid stacks (product page gallery + homepage collection cards):
       one card on top, rest peeking at angles; swipe on touch, arrows on desktop.
       v1.32.0: generalized from the single #GrindStack to EVERY .grind-stack. ---------- */
  var initGrindStack = function (stack) {
    var allStackCards = Array.prototype.slice.call(stack.querySelectorAll('.grind-stack__card'));
    /* v1.41.0 (CK): the stack works over VISIBLE cards only, so the scene
       filter can hide products and call __grindRelayout to re-deal the pile. */
    var visCards = allStackCards;
    var refreshVis = function () {
      /* v1.43.1 PERF: scene-filtered cards are marked data-off by the filter.
         Everything else is in the deck — but only the top few RENDER (see
         layoutStack); deep cards sit display:none so phones never paint or
         download 50 stacked polaroids at once. */
      visCards = allStackCards.filter(function (c) { return !c.dataset.off; });
      stack.classList.toggle('grind-stack--single', visCards.length <= 1);
    };
    /* v1.34.0 (CK): [data-shuffle] stacks deal a RANDOM order — v1.43.3: and
       RE-DEAL on every scene switch, always within the filter's constraints. */
    var doShuffle = function () {
      for (var si = allStackCards.length - 1; si > 0; si--) {
        var sj = Math.floor(Math.random() * (si + 1));
        var st = allStackCards[si]; allStackCards[si] = allStackCards[sj]; allStackCards[sj] = st;
      }
    };
    if (stack.hasAttribute('data-shuffle')) { doShuffle(); }
    var topCard = 0;
    var layoutStack = function () {
      visCards.forEach(function (c, i) {
        var pos = (i - topCard + visCards.length) % visCards.length;
        c.setAttribute('data-pos', String(Math.min(pos, 5)));
        c.style.display = pos <= 6 ? 'block' : 'none';   /* v1.43.1 PERF: render only the top of the deck (explicit block beats the pre-engine nth-child guard) */
        if (pos <= 6) {                                   /* v1.46.1 PERF: wake deferred images as cards surface */
          var di = c.querySelector('img[data-src]');
          if (di) { di.src = di.getAttribute('data-src'); di.removeAttribute('data-src'); }
        }
      });
    };
    stack.__grindRelayout = function () {
      if (stack.hasAttribute('data-shuffle')) { doShuffle(); }   /* v1.43.3: new random deal per scene switch */
      refreshVis(); topCard = 0; layoutStack();
    };
    refreshVis();
    if (allStackCards.length <= 1) { layoutStack(); return; }
    var nextCard = function () { if (visCards.length < 2) return; topCard = (topCard + 1) % visCards.length; layoutStack(); };
    var prevCard = function () { if (visCards.length < 2) return; topCard = (topCard - 1 + visCards.length) % visCards.length; layoutStack(); };
    var stackPrev = stack.querySelector('.grind-stack__arrow--prev');
    var stackNext = stack.querySelector('.grind-stack__arrow--next');
    if (stackPrev) stackPrev.addEventListener('click', prevCard);
    if (stackNext) stackNext.addEventListener('click', nextCard);
    /* swipe: horizontal drag over the stack flips the pile (vertical stays page scroll) */
    var swX = null, swY = null;
    stack.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.grind-stack__arrow')) return;
      swX = e.clientX; swY = e.clientY;
    });
    stack.addEventListener('pointerup', function (e) {
      if (swX === null) return;
      var dx = e.clientX - swX, dy = e.clientY - swY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) { nextCard(); } else { prevCard(); }
        stack.dataset.justSwiped = '1';   /* v1.35.0: swallow the click this drag produces */
        setTimeout(function () { delete stack.dataset.justSwiped; }, 120);
      }
      swX = null; swY = null;
    });
    /* v1.35.0: a swipe must never count as a click on the photo link */
    stack.addEventListener('click', function (e) {
      if (stack.dataset.justSwiped) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    stack.addEventListener('pointercancel', function () { swX = null; swY = null; });
    layoutStack();
  };
  document.querySelectorAll('.grind-stack').forEach(initGrindStack);
  var stack = document.getElementById('GrindStack');  /* product-page stack (lightbox hook) */
  if (stack && stack.querySelectorAll('.grind-stack__card').length <= 1) {
    stack.classList.add('grind-stack--single');
  }

  /* ---------- Product page: photo lightbox (tap the top polaroid = full-size popup) ---------- */
  var lb = document.getElementById('GrindLightbox');
  if (lb && stack) {
    var lbImg = document.getElementById('GrindLightboxImg');
    var lbClose = document.getElementById('GrindLightboxClose');
    var lbBackdrop = document.getElementById('GrindLightboxBackdrop');
    var lbDownX = null, lbDownY = null;
    var openLightbox = function (img) {
      lbImg.src = img.getAttribute('data-full') || img.src;
      lbImg.alt = img.alt || '';
      lb.hidden = false;
      document.documentElement.classList.add('grind-lb-lock');
    };
    var closeLightbox = function () {
      lb.hidden = true;
      document.documentElement.classList.remove('grind-lb-lock');
    };
    stack.addEventListener('pointerdown', function (e) { lbDownX = e.clientX; lbDownY = e.clientY; });
    /* open on CLICK, not pointerup: on touch, the browser synthesizes the click AFTER
       pointerup — opening in pointerup made that click land on the fresh backdrop and
       instantly close the modal. Opening on the click itself leaves no stray click. */
    stack.addEventListener('click', function (e) {
      if (lbDownX !== null) {
        var mx = Math.abs(e.clientX - lbDownX), my = Math.abs(e.clientY - lbDownY);
        lbDownX = null; lbDownY = null;
        if (mx > 10 || my > 10) return;                     /* swipe/drag, not a tap */
      }
      if (e.target.closest('.grind-stack__arrow')) return;  /* arrows flip, never zoom */
      var card = e.target.closest('.grind-stack__card');
      if (!card || card.getAttribute('data-pos') !== '0') return;  /* only the TOP photo */
      var img = card.querySelector('img');
      if (img) openLightbox(img);
    });
    lbClose.addEventListener('click', closeLightbox);
    lbBackdrop.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLightbox(); });
  }

  /* ---------- Product page: QUICK BUY (adds selected variant + qty, straight to checkout) ---------- */
  var quickBuy = document.getElementById('GrindQuickBuy');
  if (quickBuy && productForm) {
    var qbAdd = document.getElementById('GrindAddToCart');
    var qbSync = function () { quickBuy.disabled = qbAdd ? qbAdd.disabled : false; };
    productForm.querySelectorAll('select[data-option-index]').forEach(function (s) {
      s.addEventListener('change', function () { setTimeout(qbSync, 0); });  /* after resolveVariant */
    });
    quickBuy.addEventListener('click', function () {
      if (quickBuy.disabled || (qbAdd && qbAdd.disabled)) return;
      var idEl = productForm.querySelector('input[name="id"]');
      var vid = idEl ? parseInt(idEl.value, 10) : 0;
      if (!vid) return;
      var qtyEl = document.getElementById('GrindQty');
      var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
      quickBuy.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: qty })
      }).then(function (r) {
        if (!r.ok) { throw new Error('add failed'); }
        window.location.href = '/checkout';
      }).catch(function () { quickBuy.disabled = false; });
    });
  }

  /* ---------- Site-wide click wiggle (cart pick, tape-nav items, view-all picks,
       guestlist picks). v1.32.1: the homepage is NO LONGER skipped — its own
       binder still runs, but binding here too guarantees the hero nav + picks
       wiggle regardless (double-binding restarts the same animation once,
       which is harmless). Real links wiggle FIRST, then navigate; the
       guestlist JOIN NOW picks wiggle, then submit (validation respected). ---------- */
  document.querySelectorAll('.grind-header__cart, .gh-nav__item, .gh-card__viewall, .gh-cart, .fgl2-pick, .ggm-pick').forEach(function (el) {
    if (el.dataset.wgl) { return; }  /* v1.32.2: a section-level binder already claimed this element */
    el.dataset.wgl = '1';
    el.addEventListener('click', function (e) {
      var href = el.getAttribute('href');
      var doWiggle = function () { el.classList.remove('gh-wiggle'); void el.offsetWidth; el.classList.add('gh-wiggle'); };
      /* submit picks: validate, wiggle, submit a beat later so the wiggle shows */
      if (el.type === 'submit' && el.form) {
        e.preventDefault();
        doWiggle();  /* v1.32.5: wiggle FIRST like every other pick; validate after */
        setTimeout(function () { if (el.form.reportValidity()) { el.form.requestSubmit(el); } }, 380);
        return;
      }
      doWiggle();
      if (href === '#') { e.preventDefault(); return; }       /* placeholder: wiggle only */
      if (href && el.tagName === 'A' && !e.metaKey && !e.ctrlKey && el.target !== '_blank') {
        e.preventDefault();                                    /* wiggle, THEN go */
        setTimeout(function () { window.location.href = href; }, 380);
      }
    });
    el.addEventListener('animationend', function (e) {
      if (e.animationName === 'ghWiggle') { el.classList.remove('gh-wiggle'); }
    });
  });

  /* ---------- Hero video: force autoplay on mobile (muted property + playsinline + retry) ---------- */
  var heroVid = document.querySelector('.grind-canvas__media video');
  if (heroVid) {
    heroVid.muted = true;            // property form: iOS/Safari ignore the attribute alone for autoplay
    heroVid.defaultMuted = true;
    heroVid.setAttribute('muted', '');
    heroVid.playsInline = true;
    var grindTryPlay = function () { var p = heroVid.play(); if (p && p.catch) { p.catch(function () {}); } };
    grindTryPlay();
    heroVid.addEventListener('canplay', grindTryPlay, { once: true });
    document.addEventListener('touchstart', grindTryPlay, { once: true });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) grindTryPlay(); });
  }

  /* ---------- CD booklet page-flip ---------- */
  var booklet = document.getElementById('GrindBooklet');
  if (booklet) {
    var sheets = Array.prototype.slice.call(booklet.querySelectorAll('.grind-booklet__sheet'));
    var stage = booklet.querySelector('.grind-booklet__stage');
    var flipped = 0; // number of sheets currently flipped to the left
    var allPicks = Array.prototype.slice.call(booklet.querySelectorAll('.grind-booklet__buy'));

    /* Only the two pages of the visible spread may render a pick. Every other pick
       is display:none so it has NO compositing layer — on mobile a composited pick
       escapes the 3D occlusion and shows on top, which is the extra-buttons bug. */
    function showOnlyVisiblePicks() {
      allPicks.forEach(function (p) { p.style.display = 'none'; });
      if (flipped >= 1 && sheets[flipped - 1]) {
        var lp = sheets[flipped - 1].querySelector('.grind-booklet__face--back .grind-booklet__buy');
        if (lp) lp.style.display = '';
      }
      if (flipped < sheets.length && sheets[flipped]) {
        var rp = sheets[flipped].querySelector('.grind-booklet__face--front .grind-booklet__buy');
        if (rp) rp.style.display = '';
      }
    }
    function hideAllPicks() { allPicks.forEach(function (p) { p.style.display = 'none'; }); }

    function setZ() {
      sheets.forEach(function (s, i) {
        s.style.zIndex = (i < flipped) ? (i + 1) : (sheets.length - i + flipped);
      });
    }
    function apply() {
      sheets.forEach(function (s, i) {
        s.classList.toggle('is-flipped', i < flipped);
      });
      setZ();
      showOnlyVisiblePicks();
    }
    /* v1.35.0: [data-autopen="ms"] booklets start CLOSED and flip open after the
       delay (collection pages); without the attribute the old behavior stays. */
    var autopen = booklet.getAttribute('data-autopen');
    if (autopen !== null) {
      flipped = 0; apply();
      var openMs = parseInt(autopen, 10) || 500;
      setTimeout(function () { if (flipped === 0 && sheets.length > 1) { flipped = 1; apply(); } }, openMs);
      /* v1.38.0 (CK): one-time "swipe to turn" hint on touch devices, after the
         book opens; the seen-flag persists (localStorage) like the scene choice. */
      try {
        if (window.matchMedia('(hover: none)').matches && !localStorage.getItem('grindBookletSwipeSeen')) {
          var hint = document.createElement('div');
          hint.className = 'grind-booklet__swipehint grind-swipehint';
          hint.innerHTML = '<i></i><i></i><i></i><b>SWIPE TO TURN</b>';  /* v1.41.0: animated chevrons */
          stage.appendChild(hint);
          setTimeout(function () {
            hint.classList.add('is-on');
            try { localStorage.setItem('grindBookletSwipeSeen', '1'); } catch (err) {}
            setTimeout(function () { hint.classList.remove('is-on'); }, 3200);
          }, openMs + 600);
        }
      } catch (err) {}
    } else {
      if (sheets.length > 1) flipped = 1;  /* booklet starts open at the first spread */
      apply();
    }

    /* v1.38.1: the sheet that animates keeps top z until its flip completes */
    function markTurning(sheet) {
      if (!sheet) return;
      sheet.classList.add('is-turning');
      var clear = function () { sheet.classList.remove('is-turning'); sheet.removeEventListener('transitionend', clear); };
      sheet.addEventListener('transitionend', clear);
      setTimeout(clear, 900);  /* safety if transitionend never fires */
    }
    function next() { if (flipped < sheets.length) { markTurning(sheets[flipped]); flipped++; apply(); } }
    function prev() { if (flipped > 0) { markTurning(sheets[flipped - 1]); flipped--; apply(); } }

    var prevBtn = document.getElementById('GrindBookletPrev');
    var nextBtn = document.getElementById('GrindBookletNext');
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    var startX = null, active = null, dir = 0, moved = false;
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
    stage.addEventListener('pointerdown', function (e) {
      /* v1.35.2 (CK): on DESKTOP dragging does nothing — the arrows flip; touch swipes */
      if (finePointer && finePointer.matches) { return; }
      startX = e.clientX; moved = false; active = null; dir = 0;
    });
    stage.addEventListener('pointermove', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      if (!active) {
        if (dx < -12 && flipped < sheets.length) { dir = 1; active = sheets[flipped]; }
        else if (dx > 12 && flipped > 0) { dir = -1; active = sheets[flipped - 1]; }
        else return;
        active.classList.add('is-dragging');
        setZ();
        hideAllPicks();   /* no picks visible mid-turn; apply() restores the visible pair on release */
      }
      moved = true;
      var w = stage.offsetWidth / 2;
      var prog = Math.max(0, Math.min(1, (dir === 1 ? -dx : dx) / w));
      var deg = dir === 1 ? prog * -180 : (prog - 1) * 180 - 180 * 0; // forward: 0->-180; backward: -180->0
      if (dir === -1) deg = -180 + prog * 180;
      active.style.transform = 'rotateY(' + deg + 'deg)';
    });
    function endDrag(e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      if (active) {
        active.classList.remove('is-dragging');
        active.style.transform = '';
        var w = stage.offsetWidth / 2;
        var prog = Math.max(0, Math.min(1, (dir === 1 ? -dx : dx) / w));
        markTurning(active);  /* v1.38.1: finishing animation stays on top */
        if (prog > 0.3) { if (dir === 1) flipped++; else flipped--; }
        apply();
      }
      startX = null; active = null;
      if (moved && e.cancelable) e.preventDefault();
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
    /* quick-buy picks: add first available variant, bump the cart pick count */
    booklet.addEventListener('click', function (e) {
      var btn = e.target.closest('.grind-booklet__buy');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      /* v1.36.0: delegate to the shared variant picker when present */
      if (window.GrindQuickAdd) { window.GrindQuickAdd(btn); return; }
      var vid = btn.getAttribute('data-variant');
      if (!vid) return; /* mock page */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      }).then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var el = document.getElementById('GrindCartCount');
          if (el) { el.textContent = c.item_count; el.style.display = ''; }
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 450);
        }).catch(function () {});
    });

    /* suppress link clicks at the end of a real drag */
    stage.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  /* ---------- Image protection: no right-click save, no dragging ---------- */
  document.addEventListener('contextmenu', function (e) {
    if (e.target && (e.target.tagName === 'IMG' || e.target.closest('.grind-canvas, .grind-booklet, .grind-footer, .grind-productframe'))) {
      e.preventDefault();
    }
  });
  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  });

  /* ---------- Cart page: quantity auto-submit ---------- */
  document.querySelectorAll('.grind-cart-line__qty input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
  /* ---------- v1.33.1: soft fade where the inner-page artwork ends.
       Measures the background image's true proportions, sizes the fade
       overlay to the artwork's exact rendered box. No image = no fade. ---------- */
  var pbgEl = document.querySelector('.grind-canvas__bg');
  if (pbgEl) {
    var pbgUrl = (getComputedStyle(pbgEl).backgroundImage.match(/url\("?([^")]+)"?\)/) || [])[1];
    if (pbgUrl) {
      var pbgIm = new Image();
      pbgIm.onload = function () {
        if (pbgIm.naturalWidth > 0 && pbgIm.naturalHeight > 0) {
          document.documentElement.style.setProperty('--pagebg-ar', String(pbgIm.naturalWidth / pbgIm.naturalHeight));
          document.documentElement.classList.add('gbg-fade');
        }
      };
      pbgIm.src = pbgUrl;
    }
  }
})();
